module.exports = __webpack_public_path__ + "img/logo-github.822fceca.svg";